import { render, staticRenderFns } from "./notepadDetail.vue?vue&type=template&id=e0886f08"
import script from "./notepadDetail.vue?vue&type=script&lang=js"
export * from "./notepadDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports